import { Temporal } from '@js-temporal/polyfill'

import { format } from '~publish/helpers/temporal'

export function formatPostingTime(
  postingTime: string,
  twentyFourHourFormat: boolean,
  channelTimezone: string,
): string {
  if (!postingTime || postingTime === 'Next Available') {
    return 'Add to Queue'
  }

  if (postingTime === 'Prioritize') {
    return postingTime
  }

  try {
    const isoString = postingTime.replace(' ', 'T')
    const plainDateTime = Temporal.PlainDateTime.from(isoString)
    const zonedDateTime = plainDateTime.toZonedDateTime(channelTimezone)
    const currentYear = Temporal.Now.zonedDateTimeISO(channelTimezone).year
    const timestampYear = zonedDateTime.year

    const includeYear = timestampYear !== currentYear

    let dateFormat: string
    if (twentyFourHourFormat) {
      dateFormat = includeYear ? 'MMM d, yyyy, HH:mm' : 'MMM d, HH:mm'
    } else {
      dateFormat = includeYear ? 'MMM d, yyyy, h:mm a' : 'MMM d, h:mm a'
    }

    return format(zonedDateTime, dateFormat)
  } catch {
    return postingTime
  }
}
